import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { fileTransferUrls } from "./fileTransferUtils";
import { apiUrls } from "../../library/Utils";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import axios from "axios";

// Repository File Upload
export const UploadRepositoryFile = createAsyncThunk(
  "fileTransfer/UploadRepositoryFile",
  async (obj, { rejectWithValue }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = fileTransferUrls.repositoryFileUpload;

      let formData = new FormData();
      formData.append("geoID", obj.geoID);

      for (let file of obj.files) {
        formData.append("files", file);
      }

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data; 
    } catch (error) {
      console.error("UploadRepositoryFile Error", error);
      return rejectWithValue(error.response?.data || "Upload failed");
    }
  }
);

//Fetch Repository Files
export const GetRepositoryFiles = createAsyncThunk(
  "fileTransfer/GetRepositoryFiles",
  async (geoID, { rejectWithValue }) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url=fileTransferUrls.getRepositoryFiles + `?geoID=${geoID}`;
      const response = await axios.get(url,
        {
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },});
      return response.data; // The API returns a list of files
    } catch (error) {
      console.error("Error fetching repository files:", error);
      return rejectWithValue(error.response?.data || "Error fetching files");
    }
  }
);

//Delete Repository File
export const DeleteRepositoryFile = createAsyncThunk(
  "fileTransfer/DeleteRepositoryFile",
  async (fileName, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = fileTransferUrls.deleteRepositoryFile + `?fileName=${encodeURIComponent(fileName)}`;

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to delete file: ${response.statusText}`);
      }

      const result = await response.json();
      //console.log("Delete successful:", result);
      return result;
    } catch (error) {
      console.error("Delete error:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

//Download Repository File
export const DownloadRepositoryFile = createAsyncThunk(
  "fileTransfer/DownloadRepositoryFile",
  async (filepath, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = fileTransferUrls.downloadRepositoryFile + `?fileName=${encodeURIComponent(filepath)}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*", // Accept all file types
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }

      const blob = await response.blob();
      //console.log("Downloaded Blob:", blob);

      let fileName = filepath;
      const contentDisposition = response.headers.get("Content-Disposition");

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match && match[1]) {
          fileName = match[1]; // Extract filename from API response
        }
      }

      // Ensure the correct file extension if missing
      if (!fileName.includes(".")) {
        const contentType = response.headers.get("Content-Type");
        if (contentType.includes("image/png")) {
          fileName += ".png";
        } else if (contentType.includes("image/jpeg")) {
          fileName += ".jpg";
        } else if (contentType.includes("application/pdf")) {
          fileName += ".pdf";
        }
      }

      //console.log("Saving file as:", fileName);

      // Use Blob to trigger download
      const file = new Blob([blob], { type: response.headers.get("Content-Type") });
      const urlBlob = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(urlBlob);

      return blob;
    } catch (error) {
      console.error("Download error:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getScenariosData = createAsyncThunk(
  "fileTransfer/GetScenarioByCountry",
  async (countryID, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = fileTransferUrls.getScenarioByCountry + "countryId=" + countryID;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);


// Function to get request options
const getRequestOptions = (method, body = null) => {
  const data = JSON.parse(localStorage.getItem("data"));
  const token = data?.token;

  return {
      method,
      headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
      },
      ...(body && { body: JSON.stringify(body) }),
  };
};

// Function to handle API calls and error handling
const fetchData = async (url, options) => {
  try {
      const response = await fetch(url, options);
      return await response.json();
  } catch (error) {
      console.error("Error: ", error);
      throw error;
  }
};

// Function to get quota file status
export const GetQuotaFileStatus = createAsyncThunk(
  "admin/GetQuotaFileStatus",
  async (obj, thunkAPI) => {
      const { countryID, FileType, generationDate, endDate, requestedUser } = obj;
      const url =fileTransferUrls.getQuotaFileStatus +
          `?CountryID=${countryID}&FileType=${FileType}&GenerationDate=${generationDate}&endDate=${endDate}&RequestedUser=${requestedUser}`;
     
      const options = getRequestOptions("GET");
      return fetchData(url, options);
  }
);



export const GetQuotaFileGenerateStatus = createAsyncThunk(
  "admin/GetQuotaFileGenerateStatus",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    //const { scenarioID, skuPgID, duration } = obj;
    const url = fileTransferUrls.getQuotaFileGenerateStatus;
    //+`ScenarioID=${scenarioID}&ProductId=${skuPgID}&Duration=${duration}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const GetUserCountries = createAsyncThunk(
  "fileTransfer/GetUserCountries",
  async (obj) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    reqOptions.method = obj.method;
    let url = apiUrls.countryListUrl + data.userID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetFolderIdByName = createAsyncThunk(
  "fileTransfer/GetFolderIdByName",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      fileTransferUrls.getFolderIdByName + "FolderName=" + obj.FolderName;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/GetFolderIdByName Error: ", error);
    }
  }
);

export const GetFolderContent = createAsyncThunk(
  "fileTransfer/GetFolderContent",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = fileTransferUrls.getFolderContent + "id=" + obj.id;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData.items;
    } catch (error) {
      console.error("fileTransfer/GetFolderContent Error: ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "fileTransfer/DownloadFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = fileTransferUrls.downloadFile + "fileId=" + obj.fileId;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const res = await response.blob();
      const fileName = obj.fileName;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("fileTransfer/DownloadFile Error: ", error);
    }
  }
);

export const UploadFile = createAsyncThunk(
  "fileTransfer/UploadFile",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = fileTransferUrls.uploadFile;

      let formData = new FormData();
      formData.append("filePath", obj.filePath);
      formData.append("folderId", obj.folderId);
      formData.append(
        "files",
        obj.fileObj,
        obj.fileName + "." + obj.fileExtension
      );

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Disposition": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData,
      });

      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/UploadFile Error", error);
    }
  }
);

export const DeleteFile = createAsyncThunk(
  "fileTransfer/DeleteFile",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = fileTransferUrls.deleteFile + "fileId=" + obj.fileId;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/DeleteFile Error", error);
    }
  }
);

export const ProcessFile = createAsyncThunk(
  "fileTransfer/ProcessFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = fileTransferUrls.processFile;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });

      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/ProcessFile Error: ", error);
    }
  }
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isSuccess_Info: "",
  isFailed: false,
  isFailed_Info: "",
  isError: false,
  isAlert: false,
  isAlert_Info: "",
  countries: [],
  getFolderIdByName: "",
  getFolderContent: [],
  apiResponse: null,
  selectedCountry: "",
	selectedCountryID: "",
  quotaFileDate : null,
  qMStartDate: null,
  qMEndDate: null,
  repositoryFiles: [],
  scenariosData: [],
  selectedScenarioIds: [],
  clearDataValues: false,
};

const fileTransferSlice = createSlice({
  name: "fileTransfer",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
    clearStatus(state, { payload }) {
      state.isSuccess = false;
      state.isSuccess_Info = false;
      state.isFailed = false;
      state.isFailed_Info = "";
      state.isAlert=false;
      state.isAlert_Info="";
      state.selectedCountry="";
      state.selectedCountryID="";
      state.quotaFileDate =null;
      state.qMStartDate=null;
      state.qMEndDate=null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetUserCountries.fulfilled, (state, { payload }) => {
        state.countries = payload;
        state.isLoading = false;
      })
      .addCase(GetUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUserCountries", action.error.message);
      })

      .addCase(GetFolderIdByName.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderIdByName.fulfilled, (state, { payload }) => {
        state.getFolderIdByName = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderIdByName.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderIdByName", action.error.message);
      })

      .addCase(GetFolderContent.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderContent.fulfilled, (state, { payload }) => {
        state.getFolderContent = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderContent.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderContent", action.error.message);
      })

      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DownloadFile", action.error.message);
      })

      .addCase(DeleteFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DeleteFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == 1) {
          state.isSuccess = true;
          state.isSuccess_Info = "File deleted successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in DeleteFile";
        }
      })
      .addCase(DeleteFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DeleteFile", action.error.message);
      })
      .addCase(UploadRepositoryFile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UploadRepositoryFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isSuccess_Info = "Uploaded successfully";
      })
      .addCase(UploadRepositoryFile.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isFailed = true;
        state.isFailed_Info = payload || "Error occurred in UploadRepositoryFile";
      })
      .addCase(DeleteRepositoryFile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteRepositoryFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isSuccess_Info = "Deleted successfully";
      })
      .addCase(DeleteRepositoryFile.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isFailed = true;
        state.isFailed_Info = payload || "Error occurred in DeleteRepositoryFile";
      })
      .addCase(GetRepositoryFiles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetRepositoryFiles.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.repositoryFiles = payload;
      })
      .addCase(GetRepositoryFiles.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isFailed = true;
        state.repositoryFiles = [];
        console.error("Failed to fetch repository files:", payload);
      })

      .addCase(getScenariosData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenariosData.fulfilled, (state, action) => {
        debugger;
        state.scenariosData = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenariosData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenariosData", action.error.message);
      })      

      .addCase(UploadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UploadFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == "success") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
        } else if (payload == "empty") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info = "Uploaded file contains no records";
        } else if (payload == "duplicate") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info = "Uploaded file contains duplicate records";
        } else if (payload == "emptyCell") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info =
            "In the uploaded file atleast one mandatory cell is empty";
        } else if (payload == "otherSalesOrg") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info =
            "Uploaded file contains other sales organisations";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in UploadFile";
          state.isAlert = true;
          state.isAlert_Info = payload;
        }
      })
      .addCase(UploadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from UploadFile", action.error.message);
      })

      .addCase(ProcessFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ProcessFile.fulfilled, (state, { payload }) => {
        if (typeof payload == "string") {
          state.isFailed = true;
          state.isFailed_Info = payload;
        } else {
          if (payload == 1) {
            state.isSuccess = true;
            state.isSuccess_Info =
              "File is processed and moved to Archived/Processed folder";
          } else {
            state.isFailed = true;
            state.isFailed_Info =
              "File is rejected and moved to Archived/Rejected folder";
          }
        }
        state.isLoading = false;
      })
      .addCase(ProcessFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from ProcessFile", action.error.message);
      })
      .addCase(GetQuotaFileStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetQuotaFileStatus.fulfilled, (state, { payload }) => {
        //console.log("The payload is",payload);

        if (payload.length > 0 && payload[0].rowCount > 0) {
            const queuePosition = payload[0].queue + 1;
            const avgWaitTime = queuePosition * 5;

            state.isSuccess = true;
            state.isSuccess_Info = "File generation request sent successfully.";
            
            state.isAlert = true;  
            state.isAlert_Info = `Request queue position: ${queuePosition}. Average waiting time: ${avgWaitTime} minutes.`;

          } else {
            state.isFailed = true;
            state.isFailed_Info = "Quota Outbound File cannot be generated currently for this combination of country and date";
          }
        state.isLoading = false;
      })
      .addCase(GetQuotaFileStatus.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetQuotaFileStatus", action.error.message);
      })
      .addCase(GetQuotaFileGenerateStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetQuotaFileGenerateStatus.fulfilled, (state, { payload }) => {
        //console.log("The payload is",payload);

        if (payload.length > 0 && payload[0].rowCount > 0) {
            const queuePosition = payload[0].queue + 1;
            const avgWaitTime = queuePosition * 5;

            state.isSuccess = true;
            state.isSuccess_Info = "File generation request sent successfully.";
            
            state.isAlert = true;  
            state.isAlert_Info = `Request queue position: ${queuePosition}. Average waiting time: ${avgWaitTime} minutes.`;

          } else {
            state.isFailed = true;
            state.isFailed_Info = "Quota Outbound File cannot be generated currently for this combination of country and date";
          }
        state.isLoading = false;
      })
      .addCase(GetQuotaFileGenerateStatus.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetQuotaFileGenerateStatus", action.error.message);
      })      
      ;
  },
});

export const { setState, clearStatus } = fileTransferSlice.actions;

export default fileTransferSlice.reducer;
